import { getHistory, FieldType, ViewModelBase, ApiResult } from "@shoothill/core";
import { action, computed, observable, runInAction } from "mobx";

import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";
import { AllProjectCostReportModel, AllProjectCostReportRequestDTO } from "./AllProjectCostReportModel";
import moment from "moment";
import { AppUrls } from "AppUrls";
import { AllProjectReportAllProjectDTO, AllProjectReportResponseDTO } from "../Shared/AllProjectReportModelBase";
import { csvAxiosRequestConfig, exportCSV } from "Utils/Utils";

export class AllProjectCostReportViewModel extends ViewModelBase<AllProjectCostReportModel> {
    // #region Constructors and Disposers

    constructor() {
        super(new AllProjectCostReportModel());

        this.setDecorators(AllProjectCostReportViewModel);
    }

    @observable public reportViewModel: AllProjectReportAllProjectDTO | null = null;

    @observable public canExportCSV: boolean = false;

    @action
    public setCanExportCSV(val: boolean) {
        this.canExportCSV = val;
    }

    @computed
    public get getTopDateFormatted(): string {
        return this.model.reportEndDateTop ? moment(this.model.reportEndDateTop).format("DD/MM/YYYY").toString() : "Please select a date";
    }

    @computed
    public get getBottomDateFormatted(): string {
        return this.model.reportEndDateBottom ? moment(this.model.reportEndDateBottom).format("DD/MM/YYYY").toString() : "Please select a date";
    }

    // #region Client Actions

    @action
    public runReport = async (): Promise<ApiResult<AllProjectReportResponseDTO>> => {
        this.setIsLoading(true);
        const toDateBottom = this.model.reportEndDateBottom;
        const toDateTop = this.model.reportEndDateTop;
        const request: AllProjectCostReportRequestDTO = {
            toDateBottom: toDateBottom,
            toDateTop: toDateTop,
        };
        let apiResult = await this.Post<AllProjectReportResponseDTO>(AppUrls.Server.Report.AllProjects.GetAllProjectsCostReport, request);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.reportViewModel = apiResult.payload.allProject;
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    @action
    public generateAllProjectCostReportCSV = async () => {
        this.setIsLoading(true);

        const toDateBottom = this.model.reportEndDateBottom;
        const toDateTop = this.model.reportEndDateTop;
        const request: AllProjectCostReportRequestDTO = {
            toDateBottom: toDateBottom,
            toDateTop: toDateTop,
        };

        await exportCSV(AppUrls.Server.Report.AllProjects.GenerateAllProjectsCostReportCSV, request, await this.getConfig(true, csvAxiosRequestConfig)).finally(() =>
            this.setIsLoading(false),
        );
    };

    public server: ServerViewModel = new ServerViewModel();

    @action
    public reset = () => {
        this.model.reset();
        this.server.reset();
    };

    @action
    public handleCancel = (): void => {
        getHistory().goBack();
    };

    // #endregion Client Actions

    // #region Boilerplate

    public async isFieldValid(fieldName: keyof FieldType<AllProjectCostReportModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    // #region Snackbar

    @observable
    public snackbarState = false;

    @action
    public setSnackbarState = (val: boolean) => {
        this.snackbarState = val;
    };

    @observable
    public snackMessage = "";

    @action
    public setSnackMessage = (val: string) => {
        this.snackMessage = val;
    };

    @observable
    public snackType = "";

    @action
    public setSnackType = (val: string) => {
        this.snackType = val;
    };

    @observable
    public SNACKSUCCESS = "success";

    @observable
    public SNACKERROR = "error";
    // #endregion

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    // #endregion Boilerplate
}
